import { useState } from "react";
import axios from "axios";
import "./LikeButton.css";

const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

/**
 * Props:
 * - blogId       (string, required)
 * - initialLikes (number, required)
 * - initialLiked (bool, optional) whether the logged-in user already liked this
 * - token        (string, required)
 */
function LikeButton({ blogId, initialLikes = 0, initialLiked = false, token }) {
  const [likes, setLikes]   = useState(initialLikes);
  const [liked, setLiked]   = useState(initialLiked);
  const [loading, setLoading] = useState(false);

  const handleLike = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/api/blogs/${blogId}/like`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLikes(res.data.likes?.length ?? likes);
      // toggle liked state based on whether userId now appears in likes array
      const userId = localStorage.getItem("userId");
      const nowLiked = res.data.likes?.some((l) =>
        typeof l === "object" ? l._id === userId : l === userId
      );
      setLiked(nowLiked);
    } catch (err) {
      console.error("Like failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`action-btn heart-btn ${liked ? "liked" : ""}`}
      onClick={handleLike}
      disabled={loading}
    >
      <svg viewBox="0 0 24 24" className="action-icon heart-icon">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
      <span>{likes}</span>
    </button>
  );
}

export default LikeButton;